const getShortName = (name) => {
  if (!name) return '';
  const info = name.toString().split(/[ .]/);
  const shortName = [info[0][0], info[1] && info[1][0]].join('').toUpperCase();
  if (typeof TextEncoder === 'function') {
    const encoder = new TextEncoder();
    const nameEncoded = encoder.encode(shortName);
    const hasUnicode = nameEncoded.length > 2;
    if (!hasUnicode) {
      return shortName;
    }
  }
  return shortName[0];
};
export default getShortName;
